import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { Card, btnPrimary, fieldCls } from "@/components/portal/ui";

export default function AdminOperators() {
  const [ops, setOps] = useState([]);
  const load = () => http.get("/admin/operators").then((r) => setOps(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div>
      <div className="eyebrow text-[#8A998C] mb-1">Operator Management</div>
      <h1 className="font-display text-3xl text-[#1A1918] mb-1">Faculty</h1>
      <p className="text-[#6B665E] text-sm mb-8">Operator information stays modular. A future operator can take over without rebuilding the property.</p>
      {ops.map((o) => <OpEditor key={o.id} o={o} onSaved={load} />)}
    </div>
  );
}

function OpEditor({ o, onSaved }) {
  const [f, setF] = useState({ name: o.name, business_name: o.business_name, title: o.title, bio: o.bio,
    phone: o.phone, email: o.email, service_radius: o.service_radius, support_hours: o.support_hours,
    virtual_available: o.virtual_available, in_home_available: o.in_home_available, overnight_available: o.overnight_available });
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const save = async () => { try { await http.put(`/admin/operators/${o.id}`, f); toast.success("Saved"); onSaved(); } catch (e) { toast.error("Could not save"); } };

  return (
    <Card className="p-6 mb-4">
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Name"><input className={fieldCls} value={f.name} onChange={(e) => set("name", e.target.value)} /></Field>
        <Field label="Business name"><input className={fieldCls} value={f.business_name} onChange={(e) => set("business_name", e.target.value)} /></Field>
        <Field label="Title"><input className={fieldCls} value={f.title} onChange={(e) => set("title", e.target.value)} /></Field>
        <Field label="Email"><input className={fieldCls} value={f.email} onChange={(e) => set("email", e.target.value)} /></Field>
        <Field label="Phone"><input className={fieldCls} value={f.phone} onChange={(e) => set("phone", e.target.value)} /></Field>
        <Field label="Service radius"><input className={fieldCls} value={f.service_radius} onChange={(e) => set("service_radius", e.target.value)} /></Field>
        <Field label="Support hours"><input className={fieldCls} value={f.support_hours} onChange={(e) => set("support_hours", e.target.value)} /></Field>
      </div>
      <Field label="Bio"><textarea rows={3} className={`${fieldCls} mt-1`} value={f.bio} onChange={(e) => set("bio", e.target.value)} /></Field>
      <div className="flex flex-wrap gap-4 mt-4">
        {[["virtual_available", "Virtual"], ["in_home_available", "In-home"], ["overnight_available", "Overnight"]].map(([k, l]) => (
          <label key={k} className="flex items-center gap-2 text-sm text-[#1A1918]">
            <input type="checkbox" checked={f[k]} onChange={(e) => set(k, e.target.checked)} /> {l} available
          </label>
        ))}
      </div>
      <div className="mt-4"><button onClick={save} data-testid={`op-save-${o.id}`} className={btnPrimary}>Save operator</button></div>
    </Card>
  );
}
function Field({ label, children }) { return <div><label className="block text-xs text-[#8A998C] uppercase tracking-wide mb-1.5">{label}</label>{children}</div>; }
